import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core'

@Component({
  selector: 'gb-infinite-scroll',
  templateUrl: './gb-infinite-scroll.component.html',
  styleUrls: ['./gb-infinite-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbInfiniteScrollComponent implements AfterViewInit, OnDestroy {
  @Input() options: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  }
  @Input() anchorOffset = 0
  @Output() scrolled = new EventEmitter()
  @ViewChild('anchor', { static: false }) anchor!: ElementRef<HTMLElement>

  private observer?: IntersectionObserver

  ngAfterViewInit(): void {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.scrolled.emit()
        }
      }, this.options)

      this.observer.observe(this.anchor.nativeElement)

      // Manually trigger a check to see if the element is already in view
      setTimeout(() => {
        const rect = this.anchor.nativeElement.getBoundingClientRect()
        if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
          this.scrolled.emit()
        }
      }, 0)
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  getAnchorOffset(): string {
    return `${this.anchorOffset}px`
  }
}
